import Vue from 'vue';


function createSchedule(data) {
  return Vue.axios.post("/student-schedule", data);
}

function updateSchedule(scheduleId, data) {
  return Vue.axios.put(`/student-schedule/${scheduleId}`, data);
}


/**
 * Get all student schedule between date range
 * @param {*} startDate 
 * @param {*} endDate 
 * @returns 
 */
async function fetchStudentSchedulesByStudentIds(studentIds, centerId, activeOnly = true) {
  const params = {
    size: 100000,
    student_ids: studentIds ? studentIds.join(',') : null,
    active_only: activeOnly,
    center_id: centerId
  }

  return await Vue.axios
    .get("/student-schedule/by-student-ids", { params })
    .then((resp) => {
      return resp.data.content;
    })
    .catch((error) => {
      throw error
    });
}


async function getScheduleExclusionDates(scheduleIds) {
  const params = {
    schedule_ids: scheduleIds ? scheduleIds.join(',') : null
  }

  let scheduleExclusionDates = []
  await Vue.axios.get('/student-schedule/excluded-dates', { params })
    .then(resp => {
      scheduleExclusionDates = resp.data;
    })
    .catch((error) => {
      throw error
    });

  return scheduleExclusionDates;
}

async function getScheduleAssignments(scheduleIds) {
  const params = {
    schedule_ids: scheduleIds ? scheduleIds.join(',') : null
  }

  //return a map of schedule id to assignment { type: teacher|classroom, permenant, teacher | classroom}
  const schedule2Assignment = {}
  await Vue.axios.get('/student-schedule/get-teacher-assignments', { params })
    .then(resp => {
      const assignments = resp.data;
      assignments.forEach(a => {
        schedule2Assignment[a.studentScheduleId] = {
          type: 'teacher',
          permenant: a.scheduleDate ? false : true,
          teacherId: a.teacherId,
          teacherFirstName: a.teacherFirstName,
          teacherLastName: a.teacherLastName,
          notes: a.notes
        }
      })
    })
    .catch((error) => {
      throw error
    });

  await Vue.axios.get('/student-schedule/get-classroom-assignments', { params })
    .then(resp => {
      const assignments = resp.data;
      assignments.forEach(a => {
        schedule2Assignment[a.studentScheduleId] = {
          type: 'classroom',
          permenant: a.scheduleDate ? false : true,
          classroomId: a.classroomId,
          classroomName: a.classroomName,
          notes: a.notes
        }
      })
    })
    .catch((error) => {
      throw error
    });

  return schedule2Assignment;
}


/**
 * Undo the cancellation of a teacher schedule occurrence
 * @param {number} scheduleId - The ID of the teacher's schedule
 * @param {string} scheduleDate - The date of the occurrence to undo cancellation (format: "yyyy-MM-dd")
 * @returns {Promise<void>}
 */
const undoCancelOccurrence = async (scheduleId, scheduleDate) => {
  const params = { schedule_date: scheduleDate };

  return await Vue.axios
      .put(`/student-schedule/undo-cancel-occurrence/${scheduleId}`, null, { params })
      .then(() => {
          // Success response handling
      })
      .catch((error) => {
          throw error;
      });
}

export {
  createSchedule,
  updateSchedule,
  fetchStudentSchedulesByStudentIds,
  getScheduleAssignments,
  getScheduleExclusionDates,
  undoCancelOccurrence
}